import CalendarViewDaily from './CalendarViewDaily.vue';

export default CalendarViewDaily;
